/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IProcessActionsScope extends angular.IScope {
        model: models.ProcessActionsModel;
        workflowWorkspaceModel: models.WorkflowWorkspaceModel;
    }

    export class ProcessActionsController implements IController {
        private processConfigId: string;

        constructor(
            private scope: IProcessActionsScope,
            $routeParams: angular.route.IRouteParamsService,
            deleteService: services.DeleteService,
            processActionService: services.ProcessActionService,
            systemLevelService: services.SystemLevelService,
            processConfigurationService: services.ProcessConfigurationService)
        {
            this.processConfigId = $routeParams["id"];
            var processActionId = $routeParams["subId"];

            this.scope.workflowWorkspaceModel = new models.WorkflowWorkspaceModel(
                new models.WorkflowDrawingSettings(3200, 1800),
                models.WorkflowMode.ProcessAction,
                undefined);

            this.scope.model = new models.ProcessActionsModel(
                this.processConfigId,
                processActionService,
                deleteService,
                systemLevelService,
                processConfigurationService,
                (processActionGroup: models.ProcessActionGroup) => this.newProcessActionSelected(processActionGroup),
                processActionId);
        }

        private newProcessActionSelected(processActionGroup: models.ProcessActionGroup): void {
            this.scope.workflowWorkspaceModel.setNewSelectedProcessAction(this.processConfigId, processActionGroup);
            this.scope.workflowWorkspaceModel.drawShapesForToolbox();
        }
    }
}

warsApp.registerController('ProcessActionsController',
    [
        '$scope', '$routeParams', 'deleteService', 'processActionService', 'systemLevelService', "processConfigurationService"
    ]);